// tslint:disable-next-line:no-namespace
export namespace WidgetConstants {
  export enum widgetIdList {
    SLIDER = 'slider',
    NAV = 'nav',
    HEADER = 'header',
    FOOTER = 'footer',
    PRODUCT_CATEGORY = 'product-category',
    REWARDS = 'rewards',
    ORDER_LISTING = 'orders-listing',
    SALES_ORDER_DETAILS = 'sales-order-details',
    SALES_ORDER_ITEM_DETAILS = 'sales-order-item-details',
    MEMBERSHIP = 'membership',
    PRODUCT_SLIDER = 'product-slider',
    PRODUCT_DETAILS = 'product-details',
    PRODUCT_LIST = 'product-list',
    MY_VOUCHERS = 'my-vouchers',
    E_INVOICE = 'e-invoice',
    MY_VOUCHERS_DETAILS = 'my-vouchers-details',
    MY_INVOICE = 'my-invoice',
    MY_INVOICE_DETAIL = 'my-invoice-detail',
    MY_INVOICE_ITEM_DETAIL = 'my-invoice-item-detail',
    MY_INVOICE_PAYMENT = 'my-invoice-payment',
    STORE_SELECTOR = 'store-selector',
    CHECKOUT_STEP_V2 = 'checkout-step-v2',
    CHECKOUT_STEP_SENHENG = 'checkout-step-senheng',
    CARD_LAYOUT_WIDGET = 'card-layout',
    MY_PAYMENT_METHODS = 'my-payment-methods',
    MONALIZA_HOME = 'monaliza-home',
    POST_DISPLAY = 'post-display',
    COUNTDOWN_TIMER = 'countdown-timer',
    CATEGORY_TILES_LISTING = 'category-tiles-listing',
    BUTTON_SINGLE = 'button-single',
    MOBILE_HEADER = 'mobile-header',
    OUR_SERVICES = 'our-services',
    BIO_FOOTER =  'bio-footer',
    SOCIAL_FOOTER = 'social-footer',
    PRODUCT_SLIDER_V2 = 'product-slider-v2',
    SCROLL_BUTTON = 'scroll-top-button',
    WELCOME_HEADER = 'welcome-header',
    VERTICAL_MENU = 'vertical-menu',
    TAB_MENU = 'tab-menu',
    CLICKNET_HEADER = 'clicknet-header',
    GENERIC_HEADER = 'general-header',
    IMAGE_DISPLAY = 'image-display',
    SLIDER_V2 = 'slider-v2',
    COUNTRY_SELECTOR = 'country-selector',
    HORIZONTAL_MENU  = 'horizontal-menu',
    FUSION_HEADER = 'fusion-header',
    STATIC_PAGE_DISPLAY = 'static-page-display',
    MY_SHIPPING_ADDRESS = 'my-shipping-address',
    MY_SHIPPING_ADDRESS_ADD = 'my-shipping-address-add',
    MY_SHIPPING_ADDRESS_DETAILS = 'my-shipping-address-details',
    NEWS_LIST = 'news-list',
    NEWS_DETAILS = 'news-details',
    PROFILE = 'profile',
    SHOPPING_CART = 'shopping-cart',
    STORE_LOCATOR_DETAILS = 'store-locator-details',
    VOUCHER_DETAILS = 'voucher-details',
    VOUCHER_LIST = 'voucher-list',
    MY_WISHLIST = 'my-wishlist',
    CATEGORIES = 'categories',
    ECOMSYNC_PRODUCT_LIST = 'ecomsync-product-list',
    MEMBERSHIP_QR_CODE = 'membership-qr-code',
    CATEGORY_FILTER_PRODUCT_LIST = 'category-filter-product-list',
    PRODUCT_POSTS = 'product-posts',
    PRODUCT_RATING = 'product-rating',
    REWARD_LISTING = 'reward-listing',
    POWER_SEARCH_FILTER = 'power-search-filter',
    MENU_BTN = 'menu-btn',
    IMAGE_GALLERY = 'image-gallery',
    VIDEO_GALLERY = 'video-gallery',
    AUDIO_GALLERY = 'audio-gallery',
    MEDIA_PLAY_LIST = 'media-play-list',
    EXTERNAL_PRODUCT_DETAILS = 'external-product-details',
    RESELLER_WIDGET = 'reseller-widget',
    MEMBER_POINTS_COUNTER = 'membership-points-counter',
    CATEGORY_SLIDER = 'category-slider',
    OCR_HISTORY_WIDGET = 'ocr-history-widget',
    OCR_UPLOAD_WIDGET = 'ocr-upload-widget',
    OCR_VIEW_WIDGET = 'ocr-view-widget',
    IFRAME_DISPLAY = 'iframe-display',
    MENU_SLIDER = 'menu-slider',
    SLIDER_BUTTON_WIDGET = 'slider-button-widget',
    WEATHER_TIDE_FORECAST_WIDGET = 'weather-tide-forecast-widget',
    SCROLLABLE_MENU_WIDGET = 'scrollable-menu-widget',
    TEXT_WIDGET = 'text-widget',
    CALENDAR_WIDGET = 'calendar-event-widget',
    LOGIN_WIDGET = 'login',
    CARD_SLIDER_WIDGET = 'card-slider-widget',
    POST_CATEGORY_TAB = 'post-category-tab',
    IMAGE_CARD_WIDGET = 'image-card-widget',
    TEMPLATE_FORM_WIDGET = 'template-form-widget',
    MOBILE_TAB_MENU = 'mobile-tab-menu',
    MEMBER_TRANSACTIONS = 'member-transactions',
    SUPPORT_PAGES = 'support-pages',
    ACTIVITY_SCHEDULE = 'activity-schedule-widget',
    STICKY_TEXT_BUTTON = 'sticky-text-button-widget',
    BORDERED_TAB_MENU = 'bordered-tab-menu-widget',
    POST_CATEGORY_CARD = 'post-category-card',
    REQUEST_REFUND = 'request-refund',
    LOGO_WIDGET = 'logo-widget',
    HORIZONTAL_MENU_LIST = 'horizontal-menu-list-widget',
    VERTICAL_MENU_LIST = 'vertical-menu-list-widget',
    CATEGORY_CARD_WIDGET = 'category-card-widget',
    SEARCHBAR_WIDGET = 'searchbar-widget',
    VIDEO_SLIDER_WIDGET = 'video-slider-widget',
    PDF_VIEWER_WIDGET = 'pdf-viewer-widget',
    STORE_LAYOUT_INSTANCE_LISTING_WIDGET = 'store-layout-instance-listing-widget',
    WARRANTY_REGISTRATION_WIDGET = 'warranty-registration-widget',
    WARRANTY_STATUS_WIDGET = 'warranty-status-widget',
    MLM_PROGRAM_WIDGET = 'mlm-program-widget',
    DYNAMIC_FORM_WIDGET = 'dynamic-form-widget',
    POPUP_POST_WIDGET = 'popup-post-widget',
    PROMOTIONAL_WIDGET = "promotional-widget",
    EINVOICE_WIDGET = "e-invoice",
    LOGIN_V2_WIDGET = "login-v2",
    LOGIN_V3_WIDGET = "login-v3",
    PRODUCT_SUB_CAT_WIDGET = "product-sub-category",
    SELLER_ORDER_DETAILS = "seller-order-details",
    SHIPMENT_TRACKER = "shipment-tracker",
    POST_CATEGORY_SLIDER = "post-category-slider",
    GOODS_TRACKER = "goods-tracker",
    RMA_STATUS_WIDGET = "rma-status-widget",
    ENTITY_WIDGET = "entity-widget",
    NOTIFICATION_LISTING_WIDGET = "notification-listing-widget",
    RMA_APPLICATION_WIDGET = "rma-application-widget",
    WARRANTY_STATUS_DETAILS_WIDGET = "warranty-status-details-widget",
    BLOG_DASHBOARD_WIDGET = "blog-dashboard-widget",
    SENHENG_HEADER_WIDGET = "senheng-header-widget",
    CALENDAR_REMINDER_WIDGET = "calendar-reminder-listing-widget",
    CALENDAR_REMINDER_EDIT_WIDGET = "calendar-reminder-edit-widget",
    EXTERNAL_REDEEM_VOUCHER_WIDGET = "external-redeem-voucher-widget",
    CUSTOM_HEADER = "custom-header",
    PRODUCT_FILTER = "product-filter",
    JOB_SHIPMENT_LISTING = "job-shipment-listing",
    PROMO_BUNDLE = "promo-bundle",
    RESPONSIVE_HEADER = "responsive-header",
    INTERACTIVE_CONTENT_WIDGET = "interactive-content-widget",
    RELATED_CONTENT_WIDGET = "related-content-widget"
  }

  export const widgetParamConfig = [
    { name: 'SLIDER', id: widgetIdList.SLIDER, params: false },
    { name: 'NAV', id: widgetIdList.NAV, params: false },
    { name: 'HEADER', id: widgetIdList.HEADER, params: false },
    { name: 'FOOTER', id: widgetIdList.FOOTER, params: false },
    { name: 'PRODUCT CATEGORY', id: widgetIdList.PRODUCT_CATEGORY, params: true },
    { name: 'REWARDS', id: widgetIdList.REWARDS, params: false },
    { name: 'ORDER LISTING', id: widgetIdList.ORDER_LISTING, params: false },
    { name: 'MEMBERSHIP', id: widgetIdList.MEMBERSHIP, params: false },
    { name: 'PRODUCT SLIDER', id: widgetIdList.PRODUCT_SLIDER, params: true },
    { name: 'PRODUCT DETAILS', id: widgetIdList.PRODUCT_DETAILS, params: true },
    { name: 'PRODUCT LIST', id: widgetIdList.PRODUCT_LIST, params: true },
    { name: 'MY VOUCHERS', id: widgetIdList.MY_VOUCHERS, params: false },
    { name: 'MY VOUCHERS DETAILS', id: widgetIdList.MY_VOUCHERS_DETAILS, params: false },
    { name: 'MY INVOICE', id: widgetIdList.MY_INVOICE, params: true },
    { name: 'MY INVOICE_DETAIL', id: widgetIdList.MY_INVOICE_DETAIL, params: true },
    { name: 'MY INVOICE ITEM DETAIL', id: widgetIdList.MY_INVOICE_ITEM_DETAIL, params: false },
    { name: 'MY INVOICE PAYMENT', id: widgetIdList.MY_INVOICE_PAYMENT, params: true },
    { name: 'STORE SELECTOR', id: widgetIdList.STORE_SELECTOR, params: false },
    { name: 'CHECKOUT STEP V2', id: widgetIdList.CHECKOUT_STEP_V2, params: true },
    { name: 'CARD LAYOUT WIDGET', id: widgetIdList.CARD_LAYOUT_WIDGET, params: true },
    { name: 'MY PAYMENT METHODS', id: widgetIdList.MY_PAYMENT_METHODS, params: true },
    { name: 'MONALIZA HOME', id: widgetIdList.MONALIZA_HOME, params: true },
    { name: 'POST DISPLAY', id: widgetIdList.POST_DISPLAY, params: false },
    { name: 'COUNTDOWN TIMER', id: widgetIdList.COUNTDOWN_TIMER, params: true },
    { name: 'CATEGORY TILES LISTING', id: widgetIdList.CATEGORY_TILES_LISTING, params: true },
    { name: 'MOBILE HEADER', id: widgetIdList.MOBILE_HEADER, params: true },
    { name: 'BUTTON SINGLE', id: widgetIdList.BUTTON_SINGLE, params: true },
    { name: 'OUR SERVICES', id: widgetIdList.OUR_SERVICES, params: true },
    { name: 'BIO FOOTER', id: widgetIdList.BIO_FOOTER, params: true },
    { name: 'SOCIAL FOOTER', id: widgetIdList.SOCIAL_FOOTER, params: true },
    { name: 'PRODUCT SLIDER V2', id: widgetIdList.PRODUCT_SLIDER_V2, params: true },
    { name: 'SCROLL BUTTON', id: widgetIdList.SCROLL_BUTTON, params: false },
    { name: 'WELCOME HEADER', id: widgetIdList.WELCOME_HEADER, params: true },
    { name: 'VERTICAL MENU', id: widgetIdList.VERTICAL_MENU, params: true },
    { name: 'TAB MENU', id: widgetIdList.TAB_MENU, params: true },
    { name: 'CLICKNET HEADER', id: widgetIdList.CLICKNET_HEADER, params: true },
    { name: 'GENERIC HEADER', id: widgetIdList.GENERIC_HEADER, params: true },
    { name: 'IMAGE DISPLAY', id: widgetIdList.IMAGE_DISPLAY, params: true },
    { name: 'SLIDER V2', id: widgetIdList.SLIDER_V2, params: true },
    { name: 'COUNTRY SELECTOR', id: widgetIdList.COUNTRY_SELECTOR, params: true },
    { name: 'HORIZONTAL MENU', id: widgetIdList.HORIZONTAL_MENU, params: true },
    { name: 'FUSION HEADER', id: widgetIdList.FUSION_HEADER, params: true },
    { name: 'STATIC PAGE DISPLAY', id: widgetIdList.STATIC_PAGE_DISPLAY, params: true },
    { name: 'MY SHIPPING ADDRESS', id: widgetIdList.MY_SHIPPING_ADDRESS, params: true },
    { name: 'MY SHIPPING ADDRESS ADD', id: widgetIdList.MY_SHIPPING_ADDRESS_ADD, params: true },
    { name: 'MY SHIPPING ADDRESS DETAILS', id: widgetIdList.MY_SHIPPING_ADDRESS_DETAILS, params: true },
    { name: 'NEWS LIST', id: widgetIdList.NEWS_LIST, params: true },
    { name: 'NEWS DETAILS', id: widgetIdList.NEWS_DETAILS, params: false },
    { name: 'PROFILE', id: widgetIdList.PROFILE, params: false },
    { name: 'SHOPPING CART', id: widgetIdList.SHOPPING_CART, params: true },
    { name: 'STORE LOCATOR DETAILS', id: widgetIdList.STORE_LOCATOR_DETAILS, params: false },
    { name: 'VOUCHER DETAILS', id: widgetIdList.VOUCHER_DETAILS, params: false },
    { name: 'VOUCHER LIST', id: widgetIdList.VOUCHER_LIST, params: true },
    { name: 'MY WISHLIST', id: widgetIdList.MY_WISHLIST, params: false },
    { name: 'CATEGORIES', id: widgetIdList.CATEGORIES, params: true },
    { name: 'ECOMSYNC PRODUCT LIST', id: widgetIdList.ECOMSYNC_PRODUCT_LIST, params: true },
    { name: 'MEMBERSHIP QR CODE', id: widgetIdList.MEMBERSHIP_QR_CODE, params: false },
    { name: 'CATEGORY FILTER PRODUCT LIST', id: widgetIdList.CATEGORY_FILTER_PRODUCT_LIST, params: true },
    { name: 'PRODUCT POSTS', id: widgetIdList.PRODUCT_POSTS, params: true },
    { name: 'PRODUCT RATING', id: widgetIdList.PRODUCT_RATING, params: false },
    { name: 'REWARD LISTING', id: widgetIdList.REWARD_LISTING, params: false },
    { name: 'POWER SEARCH FILTER', id: widgetIdList.POWER_SEARCH_FILTER, params: true },
    { name: 'MENU BUTTON', id: widgetIdList.MENU_BTN, params: true },
    { name: 'IMAGE GALLERY', id: widgetIdList.IMAGE_GALLERY, params: true },
    { name: 'VIDEO GALLERY', id: widgetIdList.VIDEO_GALLERY, params: true },
    { name: 'AUDIO GALLERY', id: widgetIdList.AUDIO_GALLERY, params: true },
    { name: 'MEDIA PLAY LIST', id: widgetIdList.MEDIA_PLAY_LIST, params: true },
    { name: 'SALES ORDER DETAILS', id: widgetIdList.SALES_ORDER_DETAILS, params: true },
    { name: 'SALES ORDER ITEM DETAILS', id: widgetIdList.SALES_ORDER_ITEM_DETAILS, params: true },
    { name: 'EXTERNAL PRODUCT DETAILS', id: widgetIdList.EXTERNAL_PRODUCT_DETAILS, params: true },
    { name: 'RESELLER WIDGET', id: widgetIdList.RESELLER_WIDGET, params: true },
    { name: 'MEMBER POINTS COUNTER', id: widgetIdList.MEMBER_POINTS_COUNTER, params: true },
    { name: 'CATEGORY SLIDER', id: widgetIdList.CATEGORY_SLIDER, params: true },
    { name: 'OCR HISTORY LIST', id: widgetIdList.OCR_HISTORY_WIDGET, params: true },
    { name: 'OCR UPLOAD', id: widgetIdList.OCR_UPLOAD_WIDGET, params: true },
    { name: 'OCR VIEW DETAILS', id: widgetIdList.OCR_VIEW_WIDGET, params: true },
    { name: 'IFRAME DISPLAY', id: widgetIdList.IFRAME_DISPLAY, params: true },
    { name: 'MENU SLIDER', id: widgetIdList.MENU_SLIDER, params: true },
    { name: 'SLIDER BUTTON', id: widgetIdList.SLIDER_BUTTON_WIDGET, params: true },
    { name: 'WEATHER TIDE FORECAST', id: widgetIdList.WEATHER_TIDE_FORECAST_WIDGET, params: true },
    { name: 'SCROLLABLE MENU', id: widgetIdList.SCROLLABLE_MENU_WIDGET, params: true },
    { name: 'TEXT', id: widgetIdList.TEXT_WIDGET, params: true },
    { name: 'WEEKLY CALENDAR DISPLAY', id: widgetIdList.CALENDAR_WIDGET, params: true },
    { name: 'LOGIN', id: widgetIdList.LOGIN_WIDGET, params: true },
    { name: 'CARD SLIDER', id: widgetIdList.CARD_SLIDER_WIDGET, params: true },
    { name: 'POST CATEGORY TAB', id: widgetIdList.POST_CATEGORY_TAB, params: true },
    { name: 'POST CATEGORY CARD', id: widgetIdList.POST_CATEGORY_CARD, params: true },
    { name: 'IMAGE CARD', id: widgetIdList.IMAGE_CARD_WIDGET, params: true },
    { name: 'TEMPLATE FORM', id: widgetIdList.TEMPLATE_FORM_WIDGET, params: true },
    { name: 'MOBILE TAB MENU', id: widgetIdList.MOBILE_TAB_MENU, params: true },
    { name: 'MEMBER TRANSACTIONS', id: widgetIdList.MEMBER_TRANSACTIONS, params: true },
    { name: 'SUPPORT PAGES', id: widgetIdList.SUPPORT_PAGES, params: true },
    { name: 'ACTIVITY SCHEDULE', id: widgetIdList.ACTIVITY_SCHEDULE, params: true },
    { name: 'STICKY TEXT BUTTON', id: widgetIdList.STICKY_TEXT_BUTTON, params: true },
    { name: 'BORDERED TAB MENU', id: widgetIdList.BORDERED_TAB_MENU, params: true },
    { name: 'REQUEST REFUND', id: widgetIdList.REQUEST_REFUND, params: true },
    { name: 'LOGO', id: widgetIdList.LOGO_WIDGET, params: true },
    { name: 'HORIZONTAL MENU LIST', id: widgetIdList.HORIZONTAL_MENU_LIST, params: true },
    { name: 'VERTICAL MENU LIST', id: widgetIdList.VERTICAL_MENU_LIST, params: true },
    { name: 'CATEGORY CARD', id: widgetIdList.CATEGORY_CARD_WIDGET, params: true },
    { name: 'SEARCH BAR', id: widgetIdList.SEARCHBAR_WIDGET, params: true },
    { name: 'VIDEO SLIDER', id: widgetIdList.VIDEO_SLIDER_WIDGET, params: true },
    { name: 'PDF VIEWER', id: widgetIdList.PDF_VIEWER_WIDGET, params: true },
    { name: 'STORE LAYOUT INSTANCE LISTING', id: widgetIdList.STORE_LAYOUT_INSTANCE_LISTING_WIDGET, params: true },
    { name: 'WARRANTY REGISTRATION', id: widgetIdList.WARRANTY_REGISTRATION_WIDGET, params: true },
    { name: 'WARRANTY STATUS', id: widgetIdList.WARRANTY_STATUS_WIDGET, params: true },
    { name: 'MLM PROGRAM LISTING', id: widgetIdList.MLM_PROGRAM_WIDGET, params: true },
    { name: 'DYNAMIC FORM', id: widgetIdList.DYNAMIC_FORM_WIDGET, params: true },
    { name: 'PROMOTIONAL WIDGET', id: widgetIdList.PROMOTIONAL_WIDGET, params: false },
    { name: 'EINVOICE WIDGET', id: widgetIdList.EINVOICE_WIDGET, params: false },
    { name: 'LOGIN V2 WIDGET', id: widgetIdList.LOGIN_V2_WIDGET, params: false },
    { name: 'LOGIN V3 WIDGET', id: widgetIdList.LOGIN_V3_WIDGET, params: false },
    { name: 'PRODUCT SUB CATEGORY WIDGET', id: widgetIdList.PRODUCT_SUB_CAT_WIDGET, params: false },
    { name: 'SELLER ORDER DETAILS', id: widgetIdList.SELLER_ORDER_DETAILS, params: false },
    { name: 'SHIPMENT TRACKER', id: widgetIdList.SHIPMENT_TRACKER, params: false },
    { name: 'POST CATEGORY SLIDER', id: widgetIdList.POST_CATEGORY_SLIDER, params: false },
    { name: 'GOODS TRACKER', id: widgetIdList.GOODS_TRACKER, params: false },
    { name: 'RMA STATUS WIDGET', id: widgetIdList.RMA_STATUS_WIDGET, params: false },
    { name: 'ENTITY WIDGET', id: widgetIdList.ENTITY_WIDGET, params: false },
    { name: 'NOTIFICATION LISTING WIDGET', id: widgetIdList.NOTIFICATION_LISTING_WIDGET, params: false },
    { name: 'RMA APPLICATION WIDGET', id: widgetIdList.RMA_APPLICATION_WIDGET, params: false },
    { name: 'WARRANTY STATUS DETAILS WIDGET', id: widgetIdList.WARRANTY_STATUS_DETAILS_WIDGET, params: false },
    { name: 'BLOG DASHBOARD WIDGET', id: widgetIdList.BLOG_DASHBOARD_WIDGET, params: false },
    { name: 'SENHENG HEADER WIDGET', id: widgetIdList.SENHENG_HEADER_WIDGET, params: false },
    { name: 'CALENDAR REMINDER WIDGET', id: widgetIdList.CALENDAR_REMINDER_WIDGET, params: false },
    { name: 'CALENDAR REMINDER EDIT WIDGET', id: widgetIdList.CALENDAR_REMINDER_EDIT_WIDGET, params: false },
    { name: 'EXTERNAL REDEEM VOUCHER WIDGET', id: widgetIdList.EXTERNAL_REDEEM_VOUCHER_WIDGET, params: false },
    { name: 'CUSTOM HEADER', id: widgetIdList.CUSTOM_HEADER, params: false },
    { name: 'PRODUCT FILTER', id: widgetIdList.PRODUCT_FILTER, params: false },
    { name: 'JOB SHIPMENT LISTING', id: widgetIdList.JOB_SHIPMENT_LISTING, params: false },
    { name: 'PROMO BUNDLE', id: widgetIdList.PROMO_BUNDLE, params: false },
    { name: 'RESPONSIVE HEADER', id: widgetIdList.RESPONSIVE_HEADER, params: false },
    { name: 'INTERACTIVE CONTENT WIDGET', id: widgetIdList.INTERACTIVE_CONTENT_WIDGET, params: false },
    { name: 'RELATED CONTENT WIDGET', id: widgetIdList.RELATED_CONTENT_WIDGET, params: false }
  ];

  export const WIDGET_SPECIFIC_CONSTANTS = {
    [widgetIdList.PRODUCT_SLIDER_V2] : {
      PRICE_DISPLAY: 'price_display',
      POINT_DISPLAY: 'point_display'
    }
  };

  export enum PRODUCT_POSTS_CONSTANTS {
    PRODUCT_SPECIFICATION = 'Product Specifications',
    PRODUCT_DESCRIPTION = 'Product Description',
    PRODUCT_ECOM_DESCRIPTION = 'Product Ecomsync Description',
    PRODUCT_PAGES = 'Product Pages'
  }

  export enum TARGET_WINDOW_CONSTANTS {
    NEW_TAB = 'New Tab',
    NEW_WINDOW = 'New Window',
    SAME_FRAME = 'Same Frame'
  }

  export enum FILTER_PRICE_CONSTANTS {
    POPULAR = 'Popular',
    LATEST = 'Latest',
    TOP_SALES = 'Top Sales',
    PRICE = 'PRICE'
  }

  export const SALES_STATUS_CONSTANTS = [
    {name: 'ORDER RECEIVED', id: 1},
    {name: 'PAYMENT RECEIVED', id: 2},
    {name: 'PACKING IN PROGRESS', id: 3},
    {name: 'PARCEL IS  PACKED', id: 4},
    {name: 'DELIVERY IN PROGRESS', id: 5},
    {name: 'PARCEL IS RECEIVED', id: 6},
    {name: 'REVIEW IS COMPLETED', id: 7},
  ];
}
